import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, CloudIcon, LockIcon, UsersIcon } from 'lucide-react';
const securityFeatures = [{
  icon: <CloudIcon className="h-6 w-6 text-brand-teal" data-id="element-216" />,
  title: 'Cloud-based, browser access',
  description: 'Access from anywhere with no software to install or maintain.'
}, {
  icon: <LockIcon className="h-6 w-6 text-brand-teal" data-id="element-217" />,
  title: 'Data encryption',
  description: 'Your data is encrypted in transit and at rest for maximum security.'
}, {
  icon: <ShieldIcon className="h-6 w-6 text-brand-teal" data-id="element-218" />,
  title: 'Regular backups',
  description: 'Automated backups ensure your data is always protected.'
}, {
  icon: <UsersIcon className="h-6 w-6 text-brand-teal" data-id="element-219" />,
  title: 'Role-based access',
  description: 'Control exactly what each team member and client can see and edit.'
}];
export const Security = () => {
  return <section className="py-16 bg-brand-light" data-id="element-220">
      <div className="container-custom" data-id="element-221">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-222">
          <h2 className="text-3xl font-bold text-brand-blue mb-4" data-id="element-223">
            Enterprise-grade security and reliability
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-224">
            Daily Serve is built to keep your data safe and your business
            running smoothly.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-225">
          {securityFeatures.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-lg shadow-sm" data-id="element-226">
              <div className="mb-4" data-id="element-227">{feature.icon}</div>
              <h3 className="text-lg font-semibold text-brand-blue mb-2" data-id="element-228">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-229">{feature.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};